import { Account, AccountWithRealBalance } from '@algoan/dashboard/model';

export const formatAccountToAccountWithRealBalance = (
  account: Account,
  latestAnalysedDate?: Date,
): AccountWithRealBalance => {
  if (account.dailyBalances.length === 0 || !latestAnalysedDate) {
    return { ...account, realBalance: account.balance, realBalanceDate: account.balanceDate };
  }

  const { dailyBalances } = account;
  const balanceOfLatestTransaction = dailyBalances
    .slice(0)
    .reverse()
    .find((balance) => latestAnalysedDate >= new Date(balance.date));

  if (!balanceOfLatestTransaction) {
    return { ...account, realBalance: account.balance, realBalanceDate: account.balanceDate };
  }

  return {
    ...account,
    realBalance: balanceOfLatestTransaction.balance,
    realBalanceDate: latestAnalysedDate.toISOString(),
  };
};
